import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css"; 
import { Carousel } from 'react-responsive-carousel';

// Imports (paths consistent with your request)
import slide1 from '../assets/hero-futuristic-campus.png'; 
import slide2 from '../assets/1.jpg'; 
import slide3 from '../assets/2.jpg'; 
// slide4 is not used in the slides array below

const ImageCarousel = () => {
    const slides = [
        {
            url: slide1,
            alt: 'Vidulaka Futuristic Campus Interior'
        },
        {
            url: slide2,
            alt: 'Annual Prize Giving Ceremony'
        },
        {
            url: slide3,
            alt: 'Advanced Science and Innovation Lab'
        }
    ];

    return (
        <div className="w-full h-full relative group">
            {/* Background Glow */}
            <div className="absolute -inset-1 bg-gradient-to-r from-indigo-500 to-red-600 rounded-[2rem] blur opacity-20 group-hover:opacity-40 transition duration-1000"></div>
            
            <div className="relative bg-[#020617] rounded-[2rem] overflow-hidden shadow-2xl">
                <Carousel 
                    autoPlay={true} 
                    infiniteLoop={true} 
                    showThumbs={false} 
                    showStatus={false}
                    showIndicators={true}
                    interval={4000} 
                    transitionTime={800} 
                    stopOnHover={false}
                    className="main-carousel h-full" // carousel container එකටත් full height දුන්නා
                >
                    {slides.map((slide, index) => (
                        // --- මෙතනයි වෙනස තියෙන්නේ ---
                        <div key={index} className="h-[350px] md:h-[550px] relative w-full overflow-hidden"> 
                            {/* පින්තූරය පිටුපස (Background Cover එකක් වගේ) පෙනෙන්න මේ div එක හැදුවා */}
                            <div 
                                className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                                style={{ backgroundImage: `url(${slide.url})` }}
                            >
                                {/* මෙය පින්තූරයේ Cover නිමාව (object-cover) තහවුරු කරයි */}
                            </div>

                            {/* --- විකල්ප 2ක් තියෙනවා --- */}

                            {/* විකල්ප A: මම කලින් (කමෙන්ට් කරපු) code එක. 
                                මේ code එක පාවිච්චි කළොත්, `div` එකට background-image එක 
                                නොදී, `img` tag එකට `object-cover` දාන්න පුළුවන්. */}

                            {/* <div className="absolute inset-0 bg-gradient-to-t from-[#020617] via-transparent to-transparent z-10 opacity-60"></div>
                            
                            <img 
                                src={slide.url} 
                                alt={slide.alt} 
                                className="w-full h-full object-cover object-center z-0" 
                                // ^^^ w-full h-full සහ object-cover තියෙන නිසා Cover වෙනවා
                            />
                            */}
                            
                            {/* විකල්ප B (වැඩිපුර නිර්දේශිතයි): මම දැන් use කරපු background-image විදිහ. 
                                මේකෙන් පින්තූරය 100% ක්ම Cover වෙනවා. */}
                            
                            {/* Overlay Gradient (අකුරු පේන්න) */}
                            <div className="absolute inset-0 bg-gradient-to-t from-[#020617] via-transparent to-transparent z-10 opacity-70"></div>
                        </div>
                    ))}
                </Carousel>
            </div>

            
        </div>
    );
};

export default ImageCarousel;